<template>
  <v-dialog v-model="show" persistent max-width="600px">   
    <v-form v-model="paper.valid">
      <v-card v-if="show">        
        <v-card-title>
          <span class="text-h5">{{ paper.name }}</span>
        </v-card-title>
        <v-card-text class="pt-0 pb-0">
          <p class="subheading" style="float:right;">          
            Antal: {{ paper.deliveredAmount }}
          </p>
          <p class="subheading">
            {{ paper.deliveryDate | paperDate }}
          </p>
          <p v-if="paper.description">
            {{ paper.description }}
          </p>
          <v-text-field
            v-model.number="paper.receivedAmount"
            outlined
            label="Mottagit"
            type="number"
            required
            :rules="[rules.validrange(paper)]"
          />
          <v-alert
            dense
            outlined
            :value="paper.deliveredAmount === paper.receivedAmount"
            type="warning"
          >
            Du ska bara rapportera avvikelser.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="$emit('close')">
            Avbryt
          </v-btn>
          <v-btn :loading="loading" :disabled="loading || !paper.valid" @click="save(paper)">
            Spara
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import api from '@/backend/api'
import log from '@/logger'

export default {
  name: 'DeliveryDialog',
  props: {
    show: { type: Boolean, required: true },
    paper: { type: Object, required: true }
  },
  data() {
    return {
      loading: false,
      rules:{
        validrange(item){
          if(Math.sign(item.receivedAmount) === -1){
            return 'Kan inte vara negativt.'
          }
          // if(item.receivedAmount === item.deliveredAmount){
          //   return 'Du ska bara rapportera avvikelser.'
          // }        
        },             
      }
    }
  },
  methods: {
    save(paper) {
      this.loading = true

      var delivery = {
        received: paper.receivedAmount,
        delivered: paper.deliveredAmount,
        titleId: paper.titleId,
        editionId: paper.editionId,
        deliveryDate: paper.deliveryDate,
        type: paper.type
      }

      log.debug('Save Delivery:', delivery)

      api
        .saveDelivery(delivery)
        .then(resp => {
          this.loading = false
          var paper = resp.data
          log.debug('Success:', paper)
          this.$emit('saved', paper)
        })
        .catch(error => {
          this.loading = false
          log.debug('Errors:', error)
        })
    }
  }
}
</script>
